import { Card } from "@heroui/react";
import { memo } from "react";

interface ICardItem {
  title?: string | number | null;
  description: string;
  icon: React.ReactNode;
  percentage?: string;
}

interface ICards {
  showStatistics?: boolean;
  className?: string;
  items: ICardItem[];
}

const Cards: React.FC<ICards> = memo(({ showStatistics = false, className, items }) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ${className}`}>
      {items?.map((card, index) => (
        <Card key={`card-${index}-${card.description}`}>
          <div className="flex items-center gap-4 rounded-lg px-3 py-5 ">
            <div>{card.icon}</div>
            <div className="flex flex-grow flex-col gap-1">
              <div className={`flex items-center gap-2 ${showStatistics ? "justify-between" : "ms-8"}`}>
                <p className="text-2xl font-bold">{card.title}</p>
                {showStatistics && <p className="text-sm text-green-600">{card.percentage}</p>}
              </div>
              <p className="text-xs text-gray-500">{card.description}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
});

export default Cards;
